export * from './runtime.js';
export * as Constants from './constants.js';
export * as Pexpr from './pexpr.js';

export function preserves_spec_version(): string {
    return "0.996.2";
}

import type { Embeddable } from './embedded.js';
import type { Value } from './values.js';

declare global {
    interface ArrayConstructor {
        __from_preserve__<T extends Embeddable>(v: Value<T>): undefined | Array<Value<T>>;
    }
}

Array.__from_preserve__ = <T extends Embeddable>(v: Value<T>) => {
    return Array.isArray(v) ? v : void 0;
};

const _Array = Array;
type _Array<T> = Array<T>;
export { _Array as Array };

const _Symbol = Symbol;
type _Symbol = Symbol;
export { _Symbol as Symbol };
